// Script to migrate corretores to Supabase
// Run this script once to populate the database with initial corretores
// You can run this in the browser console or create a migration page

import {
  createCorretor,
  upsertVenda,
} from '../services/supabaseService';
import { corretoresIniciais } from '../data/mockData';

/**
 * Migrate all corretores from mockData to Supabase
 * This will create corretores WITHOUT vendas data (valores em branco)
 * Only basic corretor information will be migrated
 */
export const migrateCorretores = async () => {
  const results = {
    success: [],
    errors: [],
  };

  console.log('Starting migration of corretores (sem dados de vendas)...');

  for (const corretor of corretoresIniciais) {
    try {
      // Extract only corretor data, ignore vendas
      const { id, vendas, ...corretorData } = corretor;

      // Create corretor with only basic information
      // Vendas will be empty and can be filled later by the user
      const novoCorretor = await createCorretor({
        nome: corretorData.nome,
        email: corretorData.email,
        telefone: corretorData.telefone || null,
        creci: corretorData.creci || null,
        foto: corretorData.foto || null,
        ativo: corretorData.ativo !== undefined ? corretorData.ativo : true,
      });

      results.success.push({
        originalId: id,
        newId: novoCorretor.id,
        nome: novoCorretor.nome,
        email: novoCorretor.email,
      });

      console.log(`✓ Created corretor: ${novoCorretor.nome} (${novoCorretor.id})`);
    } catch (error) {
      console.error(`✗ Error creating corretor ${corretor.nome}:`, error);
      results.errors.push({
        nome: corretor.nome,
        error: error.message,
      });
    }
  }

  console.log('Migration completed!');
  console.log(`Success: ${results.success.length}`);
  console.log(`Errors: ${results.errors.length}`);

  if (results.success.length > 0) {
    console.log('\nCorretores criados com sucesso. Os valores de vendas estão em branco e podem ser preenchidos posteriormente.');
  }

  return results;
};

/**
 * Migrate corretores with vendas data (optional)
 * Use this if you want to migrate the vendas as well
 */
export const migrateCorretoresWithVendas = async () => {
  const results = {
    success: [],
    errors: [],
  };

  console.log('Starting migration of corretores with vendas...');

  for (const corretor of corretoresIniciais) {
    try {
      const { id, vendas, ...corretorData } = corretor;

      // Create corretor
      const novoCorretor = await createCorretor(corretorData);
      results.success.push({
        originalId: id,
        newId: novoCorretor.id,
        nome: novoCorretor.nome,
        vendasCount: 0,
      });

      // Migrate vendas if they exist
      if (vendas) {
        let vendasCount = 0;
        for (const [ano, meses] of Object.entries(vendas)) {
          for (const [mes, valor] of Object.entries(meses)) {
            if (valor > 0) {
              try {
                await upsertVenda(novoCorretor.id, parseInt(ano), mes, valor, 0, 0, 0);
                vendasCount++;
              } catch (vendaError) {
                console.error(`Error creating venda for ${novoCorretor.nome}:`, vendaError);
              }
            }
          }
        }
        results.success[results.success.length - 1].vendasCount = vendasCount;
      }

      console.log(`✓ Created corretor: ${novoCorretor.nome} with ${results.success[results.success.length - 1].vendasCount} vendas`);
    } catch (error) {
      console.error(`✗ Error creating corretor ${corretor.nome}:`, error);
      results.errors.push({
        nome: corretor.nome,
        error: error.message,
      });
    }
  }

  console.log('Migration completed!');
  console.log(`Success: ${results.success.length}`);
  console.log(`Errors: ${results.errors.length}`);

  return results;
};

